<script setup>
/**
 * TL;DR — the direct, self-contained answer LLMs quote (ТЗ §3.2).
 * Rendered as a plain, always-visible paragraph right under the H1.
 */
defineProps({
    text: { type: [String, null], default: null },
});
</script>

<template>
    <p v-if="text"
       class="mt-3 rounded-lg border-l-4 border-blue-500 bg-blue-50 dark:bg-slate-800/60 px-4 py-3 text-base leading-relaxed text-slate-800 dark:text-slate-100">
        {{ text }}
    </p>
</template>
